import { createAction } from 'redux-actions';
import { StreamType } from '../types';
import {
  InitializeActionParams,
  InitializeAction,
  FetchAction,
  FetchSuccessActionParams,
  FetchSuccessAction,
  InsertItemsActionParams,
  InsertItemsAction,
  FetchSuccessDedupedActionParams,
  FetchSuccessDedupeAction,
  FetchPreviousSuccessActionParams,
} from './types';
import { actionKey } from './constants';
import { FetchAllSuccessActionParams } from '../base/types';

export const STREAM__WITH_OFFSET__INITIALIZE = `${actionKey}__INITIALIZE`;
export const STREAM__WITH_OFFSET__FETCH = `${actionKey}__FETCH`;
export const STREAM__WITH_OFFSET__FETCH_SUCCESS = `${actionKey}__FETCH_SUCCESS`;
export const STREAM__WITH_OFFSET__FETCH_FAILURE = `${actionKey}__FETCH_FAILURE`;
export const STREAM__WITH_OFFSET__FETCH_RETRY = `${actionKey}__FETCH_RETRY`;
export const STREAM__WITH_OFFSET__INSERT_ITEMS = `${actionKey}__INSERT_ITEMS`;
export const STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE = `${actionKey}__FETCH_SUCCESS_DEDUPE`;

export const initialize = ({
  nextOffset,
  prevOffset,
  ...baseInitializeParams
}: InitializeActionParams): InitializeAction => ({
  ...baseInitializeParams,
  type: STREAM__WITH_OFFSET__INITIALIZE,
  streamType: StreamType.WITH_OFFSET,
  nextOffset,
  prevOffset,
});

export const fetch = (streamId: string): FetchAction => ({
  type: STREAM__WITH_OFFSET__FETCH,
  streamId,
});

export const fetchAll = (streamId: string): FetchAction => ({
  type: STREAM__WITH_OFFSET__FETCH,
  streamId,
  all: true,
});

export const fetchRetry = (streamId: string): FetchAction => ({
  type: STREAM__WITH_OFFSET__FETCH_RETRY,
  streamId,
});

export const fetchSuccess = (
  payload: FetchSuccessActionParams
): FetchSuccessAction => ({
  type: STREAM__WITH_OFFSET__FETCH_SUCCESS,
  ...payload,
});

export const fetchSuccessDeduped = (
  payload: FetchSuccessDedupedActionParams
): FetchSuccessDedupeAction => ({
  type: STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE,
  ...payload,
});

export const insertItems = ({
  streamId,
  items,
  offset,
  entities,
  doNotUpdateNextOffset,
}: InsertItemsActionParams): InsertItemsAction => ({
  type: STREAM__WITH_OFFSET__INSERT_ITEMS,
  streamId,
  items,
  offset,
  entities,
  doNotUpdateNextOffset,
});

export const fetchPrevious = createAction(
  `${actionKey}__FETCH_PREVIOUS`,
  (streamId: string) => ({ streamId })
);

export const fetchPreviousSuccess = createAction(
  `${actionKey}__FETCH_PREVIOUS_SUCCESS`,
  ({
    streamId,
    items,
    entities,
    hasLess,
    prevOffset,
    dedupeFunction,
  }: FetchPreviousSuccessActionParams) => ({
    streamId,
    items,
    entities,
    hasLess,
    prevOffset,
    dedupeFunction,
  })
);

export const fetchAllSuccess = createAction(
  `${actionKey}__FETCH_ALL_SUCCESS`,
  ({ streamId, items, entities }: FetchAllSuccessActionParams) => ({
    streamId,
    items,
    entities,
  })
);

export const emptyStream = createAction(
  `${actionKey}__EMPTY`,
  (streamId: string) => ({ streamId })
);
export const resetStream = createAction(
  `${actionKey}__RESET`,
  (streamId: string) => ({ streamId })
);

export * from '../base/actions';
